import React from 'react';
import { motion } from 'framer-motion';
import './Roadmap.css';

const roadmapPhases = [
  {
    title: 'Phase 1: Concept & Design',
    description: 'Conceptualization, game design, and setting up the foundational infrastructure for the GameFi platform.'
  },
  {
    title: 'Phase 2: Alpha Testing',
    description: 'Initial game mechanics and features will be tested in the alpha version, involving a small group of community members.'
  },
  {
    title: 'Phase 3: Public Beta Launch',
    description: 'We will release a public beta version with key features for a wider audience, gathering feedback and making improvements.'
  },
  {
    title: 'Phase 4: Official Launch',
    description: 'Our GameFi platform will officially go live with complete features, ongoing community support, and future updates.'
  }
];

const Roadmap = () => {
  return (
    <div className="roadmap-container">
      <motion.h3
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Our Development Roadmap
      </motion.h3>
      <div className="roadmap">
        {roadmapPhases.map((phase, index) => (
          <motion.div
            key={index}
            className="roadmap-phase"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.3 }}
          >
            <h4>{phase.title}</h4>
            <p>{phase.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Roadmap;
